import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ChevronRight } from "lucide-react";
import { siteConfig } from "@/config/siteConfig";

// items: [{ label, to }] — last item is current page (no link needed)
const Breadcrumbs = ({ items = [] }) => {
  if (!items.length) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: item.label,
      item: item.to ? `${siteConfig.DOMAIN}${item.to}` : undefined,
    })),
  };

  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <ol className="flex items-center flex-wrap gap-1 text-xs text-[var(--slate)]">
        {items.map((item, idx) => {
          const last = idx === items.length - 1;
          return (
            <li key={idx} className="flex items-center gap-1">
              {last || !item.to ? (
                <span aria-current={last ? "page" : undefined}>{item.label}</span>
              ) : (
                <Link to={item.to} className="hover:text-[var(--navy)]">
                  {item.label}
                </Link>
              )}
              {!last && <ChevronRight className="w-3 h-3" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
